import { render, staticRenderFns } from "./Mordgata.vue?vue&type=template&id=342d0158"
import script from "./Mordgata.vue?vue&type=script&lang=js"
export * from "./Mordgata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports